export default {
  heading: 'Maintenance in Progress',
  description: 'We are currently undergoing planned maintenance to enhance our services. Please bear with us as certain features may be temporarily unavailable. We apologize for any inconvenience caused and appreciate your patience.',
};
